export const projectsGetters: CommonGetterTree<any> = {
  getNameOrId: (_state, getters) => id => getters.getItemById(id)?.name || id
};

export default new class implements CommonStore<any, unknown> {
  name = 'projects';
  resource = '/api/v2/compute/projects';
  Model = Object;
  getters = projectsGetters;
}();
